import { combineReducers } from 'redux';
import meeting from './meeting';
import meetings from './meetings';
import race from './race';
import nextrace from './nextrace';
import earlyEntries from './earlyEntries';
import fastCards from './fastCards';
import fastResults from './fastResults';
import meetingLandingPage from './meetingLandingPage';
import horseProfile from './horseProfile';
import jockeyProfile from './jockeyProfile';
import trainerProfile from './trainerProfile';
import myStableEmailUnsubscribe from './myStableEmailUnsubscribe';
import myStableHorseSearch from './myStableHorseSearch';
import myStableTrainerSearch from './myStableTrainerSearch';
import myStableJockeySearch from './myStableJockeySearch';
import myStableEntries from './myStableEntries';
import myStableResults from './myStableResults';
import mostFollowed from './mostfollowed';
import nonRunners from './nonRunners';
import going from './going';
import rides from './rides';
import naps from './naps';
import abc from './abc';
import raceUpdate from './raceUpdate';
import insights from './insights';

export default combineReducers({
  meeting,
  meetings,
  race,
  nextrace,
  fastCards,
  fastResults,
  meetingLandingPage,
  earlyEntries,
  horseProfile,
  jockeyProfile,
  trainerProfile,
  myStableEmailUnsubscribe,
  myStableHorseSearch,
  myStableTrainerSearch,
  myStableJockeySearch,
  myStableEntries,
  myStableResults,
  mostFollowed,
  naps,
  nonRunners,
  going,
  rides,
  abc,
  raceUpdate,
  insights
});



// WEBPACK FOOTER //
// ./modules/HorseRacing/reducers/reducer.js